<div class="type-list trip-details px-3 py-4 h-100">
    <div>
        <div class="d-flex justify-content-between">
            <div class="ride-type">
                <span class="me-2 font-weight-medium fs-12">
                    {{'heading-title.booking-no' | translate | uppercase}} {{bookingDetails?.uniqueId}}
                </span>
                <span class="badge p-2"
                    [ngClass]="checkSchedule(bookingDetails.bookingTags) === this.helper.BookingType.SCHEDULE ? 'bg-danger-subtle text-danger' :'bg-info-subtle text-info'">
                    {{ checkSchedule(bookingDetails.bookingTags) === this.helper.BookingType.SCHEDULE ?
                    ('label-title.schedule'
                    |
                    translate | uppercase) : 'label-title.asap' | translate | uppercase}}
                </span>
                @if(checkSchedule(bookingDetails.bookingTags) === this.helper.BookingType.SCHEDULE){
                <p class="text-danger booking-time mt-1 mb-0">
                    {{ 
                        helper.moment(bookingDetails.bookingTime)
                        .tz(helper.displayTimezone)
                        .format(helper.DATE_FORMAT.DD_MM_YY) 
                      }} 
                      {{ 
                        helper.moment(bookingDetails.bookingTime)
                        .tz(helper.displayTimezone)
                        .format(bookingDetails.timeFormat ?? helper.TimeFormatEnum.TwentyFourHour) 
                      }}
                </p>
                }
            </div>
            <div class="time">
                <i>{{helper.moment(bookingDetails.createdAt).tz(helper.displayTimezone).format(bookingDetails?.timeFormat ?? helper.TimeFormatEnum.TwentyFourHour)}}</i>
            </div>
        </div>
        <div class="ride-location my-4">
            <div class="pickup pb-3">
                <p class="mb-0">
                    {{bookingDetails.pickupAddress.address}}
                </p>
            </div>
            @for(address of bookingDetails.destinationAddresses; track $index ; let last = $last){
            <div class="stop py-3" [ngClass]="{'pb-0 destination' : last}">
                <p class="mb-0">
                    {{address.address}}
                </p>
            </div>
            }
        </div>
        <div class="vehicle-list mb-4">
            <h5 class="mb-0">{{'label-title.choose-vehicle' | translate}}</h5>
            <div class="d-flex align-items-center justify-content-between pt-3">
                <div class="service-type d-flex align-items-center">
                    <img [src]="bookingDetails.vehicleType?.imageUrl ? helper.IMAGE_URL + bookingDetails.vehicleType.imageUrl : helper.DefaultImages.DefaultUserImage"
                        alt="" class="type-image">
                    <div class="type-name ms-4">
                        <h6 class="mb-0">{{bookingDetails.vehicleType.name}}</h6>
                        <p class="mb-0">ETA
                            {{helper.moment(bookingDetails.bookingTime).tz(helper.displayTimezone).format(bookingDetails?.timeFormat ?? helper .TimeFormatEnum.TwentyFourHour)}}
                        </p>
                    </div>
                </div>
                <button class="btn btn-primary btn-sm" (click)="viewEstimate()">{{'button-title.view-fare-estimate' |
                    translate}}</button>
            </div>
        </div>
        @if(bookingDetails.customerDetail){
        <div class="passenager-details mb-4">
            <h5 class="mb-3">{{'label-title.passenger-details' | translate}}</h5>
            <div class="d-flex align-items-start">
                <div class="">
                    <img [src]=" bookingDetails.customerDetail?.imageUrl ? helper.IMAGE_URL + bookingDetails.customerDetail.imageUrl : helper.DefaultImages.DefaultUserImage"
                        alt="driver_profile" class="booking-image" (error)="handleImageError($event)" alt="">
                </div>
                <div class="ms-3">
                    <h6 class="mb-1">{{bookingDetails.customerDetail?.name}}</h6>
                    <p class="mb-1">{{bookingDetails.customerDetail?.email}}</p>
                    <p class="mb-0">{{bookingDetails.customerDetail?.phone}}</p>
                </div>
            </div>
        </div>
        }
        @if(bookingDetails.confirmedDriver){
        <div class="passenager-details">
            <h5 class="mb-3">{{'label-title.driver-details' | translate}}</h5>
            <div class="d-flex align-items-start">
                <div class="">
                    <img [src]=" bookingDetails.confirmedDriver?.imageUrl ? helper.IMAGE_URL + bookingDetails.confirmedDriver.imageUrl : helper.DefaultImages.DefaultUserImage"
                        alt="driver_profile" class="booking-image" (error)="handleImageError($event)" alt="">
                </div>
                <div class="ms-3">
                    <h6 class="mb-1">{{bookingDetails.confirmedDriver?.name}}</h6>
                    <p class="mb-1">{{bookingDetails.confirmedDriver?.vehicleDetail.name}} {{
                        bookingDetails.confirmedDriver?.vehicleDetail ?
                        "|" : ""}}
                        @if(bookingDetails.confirmedDriver?.vehicleDetail){
                        {{bookingDetails.confirmedDriver?.vehicleDetail?.color}} |
                        {{bookingDetails.confirmedDriver?.vehicleDetail?.name}} |
                        {{bookingDetails.confirmedDriver?.vehicleDetail?.plateNo}}
                        }</p>
                </div>
            </div>
        </div>
        }
    </div>
    <div class="text-end reassign-button">
        <div class="d-flex align-items-center">
            <div class=" btn btn-soft-info" (click)="onBack()">
                <i class="ri-arrow-left-line"></i> {{'button-title.back' | translate}}
            </div>
            @if(bookingType === helper.DispatcherBookingStatusEnum.UNASSIGNED){
            <div class="btn btn-secondary ms-2" (click)="onReassignTrip()">
                {{'button-title.reassign' | translate}}
            </div>
            }
        </div>
    </div>
</div>

<app-trip-reassign-modal #reassignModal (onReassign)="reassignBooking($event)"></app-trip-reassign-modal>
<app-view-fare-estimate-modal #viewEstimateModal [isInvoice]="true"></app-view-fare-estimate-modal>